import { IntegrationContainerImageScannerWebComponent } from '..';
import { BaseIntegrationController } from '../../BaseIntegrationController';
import { SaveIntegrationWebComponent } from '../../../saveIntegration';
import { IntegrationContainerImageScannerView } from '../view/IntegrationContainerImageScannerView';
import { template } from '../view/template';
import { IntegrationContainerImageScannerRepository } from '../repository/IntegrationContainerImageScannerRepository';
import { Company } from 'apps/webcomponents/src/tagsManager/types/tag-data';
import { NewIntegration } from '../../../saveIntegration/types';
import { IntegrationTypes } from '../../../integrationsMarketplaceGridInstalled/types';
import { FormEvent } from 'apps/webcomponents/src/ui/gzForm/formField/types/form-event.enum';
import { IntegrationData } from '../../types';
import { ContainerImageScannerSpecifics } from '../types';
import { isHidden } from 'apps/webcomponents/src/utils/htmlElement.utils';

export class IntegrationContainerImageScannerController extends BaseIntegrationController {
  public component: IntegrationContainerImageScannerWebComponent;
  public dataRepository: IntegrationContainerImageScannerRepository;
  public view: IntegrationContainerImageScannerView;
  public createButton: any;
  public viewConstructor: typeof IntegrationContainerImageScannerView;
  public dataRepositoryConstructor: typeof IntegrationContainerImageScannerRepository;
  public company: Company;
  private integrationId: string;

  constructor(component: IntegrationContainerImageScannerWebComponent | SaveIntegrationWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrationContainerImageScannerView,
      viewTemplate: template,
      dataRepositoryConstructor: IntegrationContainerImageScannerRepository,
    });

    this.createButton = this.dependencies.createButton;
  }

  createIntegrationRecord(component: IntegrationContainerImageScannerWebComponent): NewIntegration {
    const record: NewIntegration = {
      companyId: component.getCompanyId(),
      name: component.getNameValue(),
      type: IntegrationTypes.ContainerImageScanner,
      specifics: {},
    };

    const viewData = component.getViewData();

    if (!viewData) {
      // If viewData is not set, we assume it's a new integration
      record.specifics = {
        userCreated: true,
      };
    }

    return record;
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$integrationFormWrapper,
        event: 'cnappIntegrationFormLoaded',
        callback: this.onIntegrationFormLoaded,
      },
      {
        element: this.view.dom.$companyFormField,
        event: FormEvent.ValueChange,
        callback: this.onCompanyFormValueChange,
      },
    ];
  }

  async onIntegrationFormLoaded() {
    // get and set server url
    const serverUrl = await this.dataRepository.getServerUrl();
    this.view.dom.$connectScannerStep4Input.value = serverUrl.server ?? '';

    // get and set access token for customer company
    if (isHidden(this.view.dom.$companyFormField)) {
      const currentCompany =
        (this.component.getViewData() as IntegrationData<ContainerImageScannerSpecifics>)?.company?.id ||
        this.dependencies.getActiveCompany().companyId;

      this.getAndRenderAccessToken(currentCompany);
    }
  }

  async getAndRenderAccessToken(companyId: string): Promise<void> {
    if (companyId) {
      const accessToken = await this.dataRepository.getAccessToken(companyId);
      this.view.dom.$connectScannerStep6Input.value = accessToken.token ?? '';
    } else {
      this.view.dom.$connectScannerStep6Input.value = '';
    }
  }

  async getDataForView(): Promise<any> {
    return {
      integrationId: this.integrationId,
      company: this.company,
    };
  }

  public setCompany(value: Company) {
    this.company = value;
  }

  public setIntegrationId(value: string) {
    this.integrationId = value;
  }

  private onCompanyFormValueChange(event: CustomEvent<{ value: string; isUserAction: boolean }>) {
    this.getAndRenderAccessToken(event.detail.value);
  }
}
